import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ApiDatabase from "server";
import useTitle from "../../hooks/TitleManager";

const PdfView = () => {
  useTitle({ title: "Ouverture fichier" });

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const fileName = searchParams.get("fileName") ?? "";
  const tokenFromQuery = searchParams.get("token") ?? "";
  const [docs, setDocs] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);

  const manageFiles = useCallback(() => {
    if (!type) {
      setDocs([]);
      return;
    }

    setIsWaiting(true);

    ApiDatabase.postPresignFiles(
      {
        type,
        fileName,
        ...(tokenFromQuery ? { token: tokenFromQuery } : {}),
      },
      (data) => {
        const urls = Array.isArray(data?.urls) ? data.urls : [];
        const docsFromLinks = urls.filter(Boolean).map((item) => {
          const href = item.url || item.uri || "";
          let originalFileName = "";
          try {
            const u = new URL(href);
            originalFileName = decodeURIComponent(
              (u.pathname.split("/").pop() || "").trim()
            );
          } catch {
            const clean = href.split("?")[0].split("#")[0];
            originalFileName = decodeURIComponent(
              (clean.split("/").pop() || "").trim()
            );
          }
          return {
            uri: href,
            fileName: originalFileName || "document",
            fileType: item.type || "application/pdf",
          };
        });
        setIsWaiting(false);
        setDocs(docsFromLinks);
      },
      (err) => {
        console.error(err);
        setDocs([]);
        setIsWaiting(false);
      }
    );
  }, [type, fileName, tokenFromQuery]);

  useEffect(() => {
    if (type) {
      manageFiles();
    }
  }, [type, manageFiles]);

  return (
    <div className="flex h-screen w-full min-h-0 flex-col overflow-hidden">
      <div className="min-h-0 min-w-0 flex-1 overflow-hidden">
        {isWaiting ? (
          <div className="flex h-full flex-col space-y-6 border-b p-6 shadow md:flex-row md:space-x-4 md:space-y-0">
            <div className="h-20 w-20 shrink-0 animate-pulse rounded bg-gray-200" />
            <div className="flex-1 space-y-3">
              <div className="h-5 w-1/3 animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-1/4 animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-2/3 animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-3/4 animate-pulse rounded bg-gray-200" />
            </div>
          </div>
        ) : docs.length > 0 ? (
          <div className="relative h-full min-h-0 w-full">
            <DocViewer
              style={{
                position: "absolute",
                inset: 0,
                minHeight: 0,
                width: "100%",
                height: "100%",
              }}
              documents={docs}
              config={{
                pdfZoom: {
                  defaultZoom: 1,
                  zoomJump: 0.1,
                },
              }}
              pluginRenderers={DocViewerRenderers}
            />
          </div>
        ) : (
          <div className="flex h-full min-h-0 flex-1 flex-col items-center justify-center overflow-y-auto px-4 text-gray-500">
            <p>Aucun document disponible</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfView;
